<ipos-sidebar></ipos-sidebar>
<article>
    <div class="header bg-white pb-6">
        <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-2 bg-white mb-4">
                    <div class="col-lg-6 col-7">
                        <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                            <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
                                <li class="breadcrumb-item">
                                    <i class="fas fa-home"></i>
                                </li>
                                <li class="breadcrumb-item">Dashboard</li>
                                <li class="breadcrumb-item active" aria-current="page">
                                    transaction-table
                                </li>
                            </ol>
                        </nav>
                        
                    </div>

                </div>
               <!-- <div class="row">
                   <div class="col-md-12">
                        <div class="card">
                            <div class="card-header bg-transparent">
                                <div class="row align-items-center">
                                    <div class="col">
                                        <h5 class="h4 mb-0">Transactions</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body border-0">
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col">Merchant</th>
                                            <th scope="col">Address</th>
                                            <th scope="col">TID</th>
                                            <th scope="col">MID</th>
                                            <th scope="col">Card Number</th>
                                            <th scope="col">Contact</th>
                                            <th scope="col">Total Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor=" let data of transactionData">
                                            <td scope="row">{{data.merchantName}}</td>
                                            <td>{{data.address}}</td>
                                            <td>{{data?.terminalId}}</td>
                                            <td>{{data?.merchantId}}</td>
                                            <td>{{data?.cardNumber}}</td>
                                            <td>{{data.contactNumber}}</td>
                                            <td>Rs. {{data?.amount}}</td>
                                        </tr>
                                       
                                    </tbody>
                                </table>
                            </div>

                        </div>
                   </div>
               </div> -->
               <div class="row">
                <div class="search-bar col-sm-6">
                    <app-search-bar (searchChange)="onSearchChanged($event)" placeholder="Search by Tid/Mid/Serialkey"></app-search-bar>
                </div>
                <div class="col-sm-3">
                    <ng-select
                    style="border-radius: 5px; border-left: 3px solid #800000"
                    [items]="status"
                    [closeOnSelect]="true"
                    [searchable]="false"
                    bindLabel="option"
                    bindValue="option"
                    [multiple]="false"
                    (change)="onStatusFilter($event)"
                    placeholder="Select Status"
                  >
                  </ng-select>
                </div> 
                <div class="export-to-excel  col-sm-3">
                    <button class="btn btn-neutral text-white"  (click)="onBtnExport()" style="padding: 5px 10px !important;" >Export Data <i class="fas fa-file-download text-white"></i> </button>
                </div> 
               </div>
               
                    <div class="p-3">
                   
                        <ag-grid-angular style=" height: 500px;"
                              class="ag-theme-balham ag-cell-focus"
                              [enableSorting]="true"
                              [enableCellTextSelection]="true"
                              [enableFilter]="true"
                              [rowData]="transactionData"
                              [rowHeight] = "40"
                              [rowHeight] = "40"
                              (gridReady)="onGridReady($event)"
                              (modelUpdated)="onModelUpdated()"
                              [pagination]="true"
                              [columnDefs]="columnDefs">
                         </ag-grid-angular>
                    </div>
            </div>
        </div>
    </div>
</article>

<!-- <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="">
                <label type="button" class="close p-4" data-dismiss="modal" aria-label="Close" style="position: absolute; right: 0; z-index: 999;">
                   <strong class="h4"> <span aria-hidden="true" class="close-modal">&times;</span></strong>
                </label>
            </div>
            <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="card p-4">
                        <div class="bg-transparent">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h2 class="h1 mb-0"><strong style="font-weight: 600;"> <span class="text-primary">Bhatbhatine
                                                Supermarket</span></strong></h2>
                                    <label class="mt-1"><i class="fa fa-map-marker mr-1"></i>Address: New Road, Pokhara-8, Kaski,
                                        Nepal</label>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <label class="small font-weight-600"><i class="fa fa-phone mr-1"></i>Phone: 9846517452</label>
                                        </div>
                                        <div class="col-md-12">
                                            <label class="small font-weight-600"><i class="fa fa-phone mr-1"></i>Deployed at: New Road Branch</label>
                                        </div>
                                        <div class="col-md-12">
                                            <label class="small font-weight-600"><i class="fa fa-user mr-1"></i>Contact person: Manoj
                                                Adhikari</label>
                                        </div>
                                        <div class="col-md-12">
                                            <label class="small font-weight-600"><i class="fa fa-align-left mr-1"></i>TID: 654613</label>
                                        </div>
                                        <div class="col-md-12">
                                            <label class="small font-weight-600"><i class="fa fa-align-left mr-1"></i>MID: 6546</label>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <label class="small font-weight-600"><i class="fa fa-align-left mr-1"></i>Serial Number: 6546</label>
                                        </div>

                                        <div class="col-md-12">
                                            <label class="small font-weight-600"><i class="fa fa-align-left mr-1"></i>Date/Time: 2021/6/15</label>
                                        </div>
                                        <div class="col-md-12">
                                            <label class="small font-weight-600"><i class="fa fa-align-left mr-1"></i>Amount: Rs. 6546</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
</div> -->